<template>
  <div>
    <g-master name="trabajos"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="parentData"
              ref="master"
              :beforeSend="master.beforeSend"
              @action="masterAction"
              @params="paramsTable"
    >
      <template slot="customButton">
        <g-btn-excel :endpoint="`${master.endpoint}_/downloadExcel`" :params="paramsExcel" fileName="segmento"/>
      </template>
      <span slot="iconRenderer" slot-scope="{text}">
            <a-avatar @click="loadPicture(text)" v-if="! $isEmpty(text)">
              <a-icon slot="icon" type="file-image"/>
            </a-avatar>
      </span>
      <span slot="estadoRenderer" slot-scope="{text}">
                        <a-tag
                          :color="text==='INACTIVO' ? 'red' : (text === 'ACTIVO' ? 'blue' : 'red')">{{text}}</a-tag>
          </span>
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Descripción')">
              <a-textarea autoSize
                          v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Orden')">
              <a-input-number style="width: 100%"
                              v-decorator="['order', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Estado')" :has-feedback="false">
              <a-checkbox v-decorator="['status', {valuePropName: 'checked', initialValue: false}]">
              </a-checkbox>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Icono')">
              <a-input style="width: 100%"
                       v-decorator="['icon', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </g-master>
    <a-tabs default-active-key="1">
      <a-tab-pane tab="COMPONENTE" key="1">
        <skill v-if="idSubgroup" :id_subgroup="idSubgroup" :id_evaluation="id_evaluation"></skill>
        <span v-else>Seleccione un subgrupo para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        tipoObjetivo: {
          h_lookup_type: 'TIPO_OBJETIVO_EVALUACION_'
        },
        colOptions: {xs: 24, sm: 24},
        visible: false,
        nombre: '',
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          uploads: {
            profileFile: []
          },
          beforeSend: (data) => {
            if (this.master.uploads.profileFile.length > 0) {
              data.profileFile = this.master.uploads.profileFile[0]
            }
            data.id_level = this.id_level
            return data
          },
          endpoint: 'skill_subgroup',
          tableSetup: {
            customSlots: ['estadoRenderer'],
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Descripción', dataIndex: 'name', sorter: true},
              {title: 'Orden', dataIndex: 'order', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'status_desc',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Icono', dataIndex: 'icon', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'name'},
            {name: 'order'},
            {name: 'status', type: 'boolean'},
            {name: 'icon'}
          ]
        },
        paramsT: {}
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    props: ['id_group', 'id_evaluation'],
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            if (action.record.status === '1') {
              this.$refs.master.modal.form.setFieldsValue({
                status: true
              })
            } else {
              this.$refs.master.modal.form.setFieldsValue({
                status: false
              })
            }
            break
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      parentData () {
        return {
          id_group_skill: this.id_group
        }
      },
      idSubgroup () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns, ...this.parentData}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/SkillsSubgroup.vue